import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const FormLabel = (props) => {
    const containerClass = [props.className || '', css(styles.container)].join(' ');
    return React.createElement("div", { className: containerClass }, props.children);
};
const styles = StyleSheet.create({
    container: {
        fontSize: '.75rem',
        color: Colors.GrayDarkest,
        [MediaBreakPointUp.MD]: {
            fontSize: '.875rem',
        },
    },
});
